import * as amplitude from "@amplitude/analytics-react-native"

/**
 * Les événements Amplitude du test d'entrée.
 *
 * Ils servent à une chose : savoir quels barreaux du dépannage résolvent
 * vraiment, lesquels sont passés, et combien d'élèves entrent par le chemin
 * court. Sans ces mesures, les échelles ne peuvent ni raccourcir ni changer.
 *
 * Toutes les propriétés sont en snake_case, comme le reste des événements de
 * l'app. Le contexte commun (`live_session_id`, `platform`, `browser`) est
 * ajouté par l'appelant.
 */
export const PRECALL_EVENT = {
    /** L'écran d'entrée s'affiche. `memory_hit` : le chemin court s'applique. */
    OPENED: "precall.opened",
    /** Un voyant rend un verdict mesuré (jamais `pending`). */
    STEP_VERDICT: "precall.step.verdict",
    /** Un barreau de dépannage s'affiche. */
    RUNG_SHOWN: "precall.rung.shown",
    /** Ce que le barreau a donné : `resolved`, `next` (essai suivant) ou `skipped`. */
    RUNG_RESULT: "precall.rung.result",
    /** L'élève entre en séance depuis cet écran. */
    JOIN: "precall.join",
    /** Le signalement automatique est parti vers l'équipe. */
    ALERT_SENT: "precall.alert.sent",
}

/**
 * Un envoi qui ne casse jamais l'écran : la mesure est secondaire, l'entrée en
 * cours ne l'est pas.
 */
export function trackPrecall(event, properties = {}) {
    try {
        amplitude.track(event, properties)
    } catch (error) {
        // Rien : un échec de mesure ne doit rien changer pour l'élève.
    }
}
